import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useParams, useNavigate } from "react-router-dom";
import { useApi } from "../api/useApi";

const EditBuyerPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch } = useApi();
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState({
    id: id,
    email: "",
    firstName: "",
    lastName: "",
    whatsappPhone: "",
    phone: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  useEffect(() => {
    const fetchBuyer = async () => {
      try {
        const response = await authFetch(`/admin/buyer/${id}`);
        if (!response.ok) throw new Error("Failed to fetch buyer");
        const data = await response.json();
        setFormValues(data);
      } catch (err) {
        console.error("Failed to fetch buyer", err);
        setSnackbar({ open: true, message: "Error loading buyer", severity: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchBuyer();
  }, [id, authFetch]);

  const handleChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await authFetch(`/admin/buyer/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValues),
      });

      if (!response.ok) throw new Error("Update failed");

      setSnackbar({
        open: true,
        message: "Buyer updated successfully",
        severity: "success",
      });

      setTimeout(() => navigate("/admin/buyers"), 1000);
    } catch (error) {
      console.error("Update error:", error);
      setSnackbar({ open: true, message: "Failed to update buyer", severity: "error" });
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box maxWidth="md" mx="auto" mt={4}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h6" mb={2}>
          Edit Buyer
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={formValues.firstName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={formValues.lastName}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formValues.email}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Phone (Including countrycode)"
              name="phone"
              value={formValues.phone}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="WhatsApp Phone (Including countrycode)"
              name="whatsappPhone"
              value={formValues.whatsappPhone}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Update Buyer
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

export default EditBuyerPage;